/**
 * Quick-chat's two layers: the screen-space bubble layer and the phrase
 * menu, both empty skeletons on purpose -- packages/client/src/chat.js fills them from
 * shared/phrases.js so the page can never say a word the table does not.
 */
import "./chat.css";
import { mount } from "./dom.js";

export function mountChat() {
  const bubbles = mount(`
<!-- Quick-chat (packages/client/src/chat.js).  Both are empty skeletons on purpose:
     the bubbles are made per phrase, and the menu is built from
     shared/phrases.js so this file never lists a phrase it could get wrong.
     aria-live on the bubble layer because the bubbles ARE the chat; a
     reader hears what a sighted player reads over the cats' heads. -->
<div id="bubbles" aria-live="polite"></div>`);
  const chat = mount(`
<div id="chat" class="panel hidden" role="dialog" aria-label="Say something"></div>`);
  return { bubbles, chat };
}
